import React, { Fragment, useState } from "react";
import {
  Button,
  ButtonColors,
  ButtonStyles,
  ButtonTypes,
  Input,
} from "icr-shared-components/dist";
import { useHistory } from "react-router";
import { RootState } from "../../reducers";
import { bindActionCreators, Dispatch } from "redux";
import { Action } from "../../actions";
import {
  setNewRestoreEmailAddress,
  updateProfileLoginData,
} from "../../actions/profile";
import { connect } from "react-redux";
import { formConfig } from "./formConfig";
import { useValidateFrom } from "../../utils/useValidateFrom";
import { getRouteByLanguage, DefaultRouteNames } from "../../routes";

interface Props {
  profileLoginData: any;
  updateProfileLoginData: any;
}

const Recovery = ({ profileLoginData, updateProfileLoginData }: Props) => {
  const [restoreEmail, setRestoreEmail] = useState("");
  const [isBlurred, setIsBlurred] = useState(false);

  const history = useHistory();
  const validation = useValidateFrom("profile", formConfig, { restoreEmail });

  const handleSubmit = async (e) => {
    const payload = {
      ...profileLoginData,
      restoreEmailAddress: restoreEmail,
    };
    const response = await updateProfileLoginData(payload);
    console.log(response);
  };

  return (
    <Fragment>
      <p className="mb-48">
        Geben Sie eine Wiederherstellungs E-Mail-Adresse ein. Diese muss sich
        von der primären E-Mail-Adresse unterscheiden. Lassen Sie sich dann ein
        Bestätigungsmail senden. Im Mail finden Sie einen Link um die
        E-Mail-Adresse zu bestätigen.
      </p>

      <div className="row">
        <div className="col-md-5 col-xs-12">
          <Input
            type="text"
            name="email"
            value={restoreEmail}
            onChange={(name, value) => setRestoreEmail(value)}
            placeholder="Wiederherstellungs-E-Mail-Adresse eingeben"
            inputWrapperClass="mb-48"
            onBlur={() => setIsBlurred(true)}
            validationMessageConfig={
              (isBlurred ||
                validation?.restoreEmail?.validation?.type === "success") && {
                config: validation.restoreEmail.validation,
                visible: true,
              }
            }
          >
            Ihre neue Wiederherstellungs-E-Mail-Adresse
          </Input>
        </div>
      </div>

      <div className="modal-buttons">
        <Button
          type={ButtonTypes.Text}
          color={ButtonColors.Action}
          onClick={() =>
            history.push(getRouteByLanguage(DefaultRouteNames.PROFILE))
          }
        >
          abbrechen
        </Button>

        <Button
          type={ButtonTypes.Standard}
          style={ButtonStyles.Primary}
          color={ButtonColors.Action}
          onClick={handleSubmit}
        >
          bestätigen
        </Button>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  profileLoginData: state.profile.profileLoginData,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  updateProfileLoginData: bindActionCreators(updateProfileLoginData, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Recovery);
